module.exports = __webpack_public_path__ + "static/media/ic-shopping-cart-small.5d26a57a.svg";